import { QueryOptions } from 'react-query';
import { getOrgsWithFarmAccess } from './farm-orgs.api';
import { FarmOrgAccessResponse } from './farm-orgs.schema';

export const getFarmOrgsQuery = (
  solarFarmId: number,
  solarFarmOrgId: number,
): QueryOptions<FarmOrgAccessResponse> => ({
  queryKey: ['farm-orgs', { solarFarmOrgId, solarFarmId }],
  queryFn: () => getOrgsWithFarmAccess(solarFarmId, solarFarmOrgId),
});
